"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyForRefundUI = void 0;
var nebula_1 = require("@ovotech/nebula");
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var screen_reader_route_manager_1 = __importDefault(require("screen-reader-route-manager"));
var core_1 = require("../../../../../shared/core");
var components_1 = require("../../../../../shared/core/components");
var analytics_subjects_1 = require("../../../analytics-subjects");
var constants_1 = require("../../../constants");
var copy_1 = require("../../../copy");
var data_1 = require("../../../data");
var utils_1 = require("../../../utils");
var session_storage_1 = require("../../../utils/session-storage");
var components_2 = require("./components");
var ApplyForRefundUI = function (_a) {
    var _b, _c;
    var accountId = _a.accountId, customerId = _a.customerId, eligibilityData = _a.eligibilityData;
    var _d = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _d.copy, Copy = _d.Copy;
    var _e = __read((0, react_1.useState)(''), 2), refundAmount = _e[0], setRefundAmount = _e[1];
    var _f = __read((0, react_1.useState)([]), 2), errors = _f[0], setErrors = _f[1];
    var _g = __read((0, react_1.useState)(false), 2), applyForPayoutError = _g[0], setapplyForPayoutError = _g[1];
    var _h = (0, core_1.useLinks)(), payments = _h.payments, refundConfirm = _h.refundConfirm, refundNotEligible = _h.refundNotEligible;
    var navigate = (0, ui_tools_1.useNavigate)();
    var _j = (0, core_1.useComponents)(), ButtonGroup = _j.ButtonGroup, Stack = _j.Stack, ErrorSummaryNotification = _j.ErrorSummaryNotification, Card = _j.Card, Heading1 = _j.Heading1, CurrencyField = _j.CurrencyField, PrimaryCTAButton = _j.PrimaryCTAButton, Margin = _j.Margin, ErrorSection = _j.ErrorSection;
    var retailer = core_1.configService.getConfig().retailer;
    var currencyCode = (0, utils_1.getCurrency)(retailer.currencyCode).code;
    var _k = (0, data_1.useApplyForPayout)({
        accountId: accountId,
        customerId: customerId,
    }), mutate = _k.mutate, loading = _k.loading;
    var handleChange = function (e) {
        setRefundAmount(e.currentTarget.value);
    };
    var handleError = function (message) {
        setErrors([
            {
                id: 'amount',
                message: message,
            },
        ]);
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        if (!/^\d+(\.\d\d?)?$/.test(refundAmount)) {
            handleError(copy('applyValidNumberError'));
        }
        else if (Number(refundAmount) < eligibilityData.minimumAmount ||
            Number(refundAmount) > eligibilityData.maximumAmount) {
            handleError(copy('applyValidRangeError', {
                min: (0, core_1.major2DP)((0, core_1.majorToMinor)(eligibilityData.minimumAmount)),
                max: (0, core_1.major2DP)((0, core_1.majorToMinor)(eligibilityData.maximumAmount)),
            }));
        }
        else {
            mutate({
                amount: Number(refundAmount),
            }, {
                onError: function (_a) {
                    var reasonCode = _a.reasonCode;
                    if (reasonCode) {
                        screen_reader_route_manager_1.default.beforeRouteChange();
                        navigate({
                            pathname: refundNotEligible(),
                            search: "?reason=".concat(reasonCode),
                        });
                    }
                    else {
                        setapplyForPayoutError(true);
                    }
                },
                onCompleted: function () {
                    screen_reader_route_manager_1.default.beforeRouteChange();
                    var payoutAccount = {
                        accountId: accountId,
                        payoutRequested: true,
                        expiresAt: (0, date_fns_1.addMinutes)(Date.now(), 1).getTime(),
                    };
                    (0, session_storage_1.updatePayoutAccounts)(payoutAccount);
                    navigate(refundConfirm());
                },
            });
        }
    };
    var hintText = copy('applyHintText', {
        max: (0, core_1.major2DP)((0, core_1.majorToMinor)(eligibilityData.maximumAmount)),
        min: (0, core_1.major2DP)((0, core_1.majorToMinor)(eligibilityData.minimumAmount)),
    });
    if (applyForPayoutError) {
        return (react_1.default.createElement(ErrorSection, { id: "api-error", errorMetadata: { applyForPayoutError: applyForPayoutError } }));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ErrorSummaryNotification, { id: "error-summary", errors: errors }),
        react_1.default.createElement(Card, null,
            react_1.default.createElement(Stack, { spaceBetween: [2, 4] },
                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.APPLY_FOR_REFUND_CANCEL, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
                    react_1.default.createElement(components_1.Breadcrumb, { "data-testid": "breadcrumb", href: payments() }, react_1.default.createElement(Copy, { copyKey: "backtoPaymentsBreadcrumb" }))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Heading1, null,
                        react_1.default.createElement(Copy, { copyKey: "applyTitle" })),
                    react_1.default.createElement(Copy, { copyKey: "applyBody", values: {
                            currentBalance: (0, core_1.major2DP)((0, core_1.majorToMinor)(eligibilityData.balance)),
                            refundProcessingDays: constants_1.REFUND_PROCESSING_DAYS,
                        } })),
                react_1.default.createElement("form", { onSubmit: handleSubmit, method: "PUT", noValidate: true },
                    react_1.default.createElement(Stack, { spaceBetween: [2, 4] },
                        react_1.default.createElement(CurrencyField, { id: "amount", "data-testid": "payout-amount", label: copy('applyAmountLabel'), value: refundAmount, min: eligibilityData.minimumAmount, max: eligibilityData.maximumAmount, step: 1, onChange: handleChange, error: (0, nebula_1.getErrorMessage)('amount', errors), hint: hintText, characters: 4, currency: currencyCode }),
                        react_1.default.createElement(ButtonGroup, null,
                            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.APPLY_FOR_REFUND_SUBMIT, properties: (_c = {}, _c[core_1.INTERNAL_EVENT_FLAG] = true, _c) },
                                react_1.default.createElement(PrimaryCTAButton, { type: "submit", disabled: loading, id: "refund-submit", "data-testid": "one-stop-refund:apply" },
                                    react_1.default.createElement(Copy, { copyKey: "applySubmit" })))))))),
        react_1.default.createElement(Margin, { top: [4, 8] },
            react_1.default.createElement(components_2.BalanceEncouragement, null))));
};
exports.ApplyForRefundUI = ApplyForRefundUI;
